// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2k2Ct","label":"styles_label__2nEop"};